import { Link } from 'react-router-dom';

import { cn } from '~lib/utils/style';

import { buttonVariants } from '~ui/base/button';
import { Typography } from '~ui/base/typography';

function NotFoundPage() {
  return (
    <div className="flex flex-col items-start gap-y-4 pt-24">
      <Typography variant="overline" as="p" className="text-muted-foreground">
        404
      </Typography>
      <Typography variant="headline-lg" as="h1">
        That page couldn&rsquo;t be found
      </Typography>
      <Typography variant="body-lg" as="p" className="text-muted-foreground-dark">
        Check the URL, or head back to the search.
      </Typography>
      <Link to="/" className={cn(buttonVariants({ variant: 'primary', size: 'lg' }))}>
        Back to search
      </Link>
    </div>
  );
}

export { NotFoundPage };
